.group {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.label {
  margin: 0;
  font-size: 12px;
  color: rgb(233 233 237 / 0.7);
}

.row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.swatch {
  width: 26px;
  height: 26px;
  flex: none;
  padding: 0;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid rgb(233 233 237 / 0.2);
}

.swatch[data-selected='true'] {
  border: 2px solid #161826;
  box-shadow: 0 0 0 2px var(--color-accent);
}

.picker {
  position: relative;
  width: 26px;
  height: 26px;
  flex: none;
  border-radius: 50%;
  overflow: hidden;
  display: grid;
  place-items: center;
  cursor: pointer;
  border: 1px solid rgb(233 233 237 / 0.25);
  background: conic-gradient(#e15c5c, #e1c65c, #7fd07f, #5cc7e1, #9184d9, #d05cc7, #e15c5c);
}

.picker > span {
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text);
  text-shadow: 0 1px 2px rgb(0 0 0 / 0.6);
  pointer-events: none;
}

.picker > input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  border: 0;
  padding: 0;
}

.picker:has(input:focus-visible) {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

@media (min-width: 900px) {
  .swatch,
  .picker {
    width: 28px;
    height: 28px;
  }
}
